import { render, staticRenderFns } from "./moneyTip.vue?vue&type=template&id=467d7c18&scoped=true&"
import script from "./moneyTip.vue?vue&type=script&lang=js&"
export * from "./moneyTip.vue?vue&type=script&lang=js&"
import style0 from "./moneyTip.vue?vue&type=style&index=0&id=467d7c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d7c18",
  null
  
)

export default component.exports